import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeType } from '../../../types/command';
import {
  HeroSection,
  HeroPrompt,
  HeroName,
  HeroTagline,
  HeroCTA,
  HeaderButton,
} from '../styles';

interface HeroProps {
  themeName: ThemeType;
  onSwitchToTerminal: () => void;
  onSwitchToServices: () => void;
  onDownloadCV: () => void;
}

const Hero: React.FC<HeroProps> = ({ themeName, onSwitchToTerminal, onSwitchToServices, onDownloadCV }) => {
  const { t } = useTranslation();
  const [showName, setShowName] = useState(false);
  const [showTagline, setShowTagline] = useState(false);
  const [showCTA, setShowCTA] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShowName(true), 300);
    const t2 = setTimeout(() => setShowTagline(true), 700);
    const t3 = setTimeout(() => setShowCTA(true), 1000);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  return (
    <HeroSection $themeName={themeName}>
      <HeroPrompt $themeName={themeName}>$ whoami</HeroPrompt>
      <HeroName
        $themeName={themeName}
        style={{
          opacity: showName ? 1 : 0,
          transform: showName ? 'translateY(0)' : 'translateY(10px)',
          transition: 'all 0.5s ease',
        }}
      >
        {'> '}anil_orhan
      </HeroName>
      <HeroTagline
        $themeName={themeName}
        style={{
          opacity: showTagline ? 1 : 0,
          transform: showTagline ? 'translateY(0)' : 'translateY(10px)',
          transition: 'all 0.5s ease',
        }}
      >
        {t('ClassicPage.tagline')}
      </HeroTagline>
      <HeroCTA
        style={{
          opacity: showCTA ? 1 : 0,
          transform: showCTA ? 'translateY(0)' : 'translateY(10px)',
          transition: 'all 0.5s ease',
        }}
      >
        <HeaderButton $themeName={themeName} $variant="primary" onClick={onDownloadCV}>
          {t('ClassicPage.nav.downloadCV')}
        </HeaderButton>
        <HeaderButton $themeName={themeName} onClick={onSwitchToTerminal}>
          Open Terminal
        </HeaderButton>
        <HeaderButton $themeName={themeName} onClick={onSwitchToServices}>
          {t('ClassicPage.switchToServices')}
        </HeaderButton>
      </HeroCTA>
    </HeroSection>
  );
};

export default Hero;
